import Vue from 'vue';
import VXETable from 'vxe-table';
// component
import FilterInput from '@/components/widgets/VxeTable/FilterInput';
import FilterSelect from '@/components/widgets/VxeTable/FilterSelect';
import FilterDaterange from '@/components/widgets/VxeTable/FilterDaterange';
import FilterSwitch from '@/components/widgets/VxeTable/FilterSwitch';
import FilterMultiSelect from '@/components/widgets/VxeTable/FilterMultiSelect';


// free text
Vue.component(FilterInput.name, FilterInput)
VXETable.renderer.add('FilterInput', {
  isFooter: false,
  renderFilter (h, renderOpts, params) {
    return [
      <filter-input params={ params } renderOpts={ renderOpts }></filter-input>
    ]
  },
  filterMethod ({ option, row, column }) {
    return {option, row, column};
  }
});

// select
Vue.component(FilterSelect.name, FilterSelect)
VXETable.renderer.add('FilterSelect', {
  isFooter: false,
  renderFilter (h, renderOpts, params) {
    return [
      <filter-select params={ params } renderOpts={ renderOpts }></filter-select>
    ]
  },
  filterMethod ({ option, row, column }) {
    return {option, row, column};
  }
});

// multi select
Vue.component(FilterMultiSelect.name, FilterMultiSelect)
VXETable.renderer.add('FilterMultiSelect', {
  isFooter: false,
  renderFilter (h, renderOpts, params) {
    return [
      <filter-multi-select params={ params } renderOpts={ renderOpts }></filter-multi-select>
    ]
  },
  filterMethod ({ option, row, column }) {
    console.log("received option: ",option.data);
    return {option, row, column};
  }
});

// daterange
Vue.component(FilterDaterange.name, FilterDaterange)
VXETable.renderer.add('FilterDaterange', {
  isFooter: false,
  renderFilter (h, renderOpts, params) {
    return [
      <filter-daterange params={ params } renderOpts={ renderOpts }></filter-daterange>
    ]
  },
  filterMethod ({ option, row, column }) {
    console.log("received option: ",option.data);
    return {option, row, column};
  }
});

// switch
Vue.component(FilterSwitch.name, FilterSwitch)
VXETable.renderer.add('FilterSwitch', {
  isFooter: false,
  renderFilter (h, renderOpts, params) {
    return [
      <filter-switch params={ params } renderOpts={ renderOpts }></filter-switch>
    ]
  },
  filterMethod ({ option, row, column }) {
    console.log("received option: ",option.data);
    return {option, row, column};
  }
});